import React from 'react';
import LayoutPicker from './layout-picker';
import { LayoutMode } from './types';
import * as S from './styles';

type Props = {
  layoutModes: ReadonlyArray<LayoutMode>;
  activeLayout: LayoutMode;
  setLayout: (layout: LayoutMode) => void;
};

const LayoutButtons = ({ activeLayout, layoutModes, setLayout }: Props) => {
  return layoutModes.length > 1 ? (
    <S.LayoutButtonContainer>
      {layoutModes.includes(LayoutMode.GRID) && layoutModes.length > 1 && (
        <LayoutPicker
          active={activeLayout === LayoutMode.GRID}
          mode={LayoutMode.GRID}
          onClick={() => setLayout(LayoutMode.GRID)}
        />
      )}

      {layoutModes.includes(LayoutMode.LIST) && layoutModes.length > 1 && (
        <LayoutPicker
          active={activeLayout === LayoutMode.LIST}
          mode={LayoutMode.LIST}
          onClick={setLayout}
        />
      )}

      {layoutModes.includes(LayoutMode.COMPACT_LIST) &&
        layoutModes.length > 1 && (
          <LayoutPicker
            active={activeLayout === LayoutMode.COMPACT_LIST}
            mode={LayoutMode.COMPACT_LIST}
            onClick={setLayout}
          />
        )}

      {layoutModes.includes(LayoutMode.TABLE) && layoutModes.length > 1 && (
        <LayoutPicker
          active={activeLayout === LayoutMode.TABLE}
          mode={LayoutMode.TABLE}
          onClick={setLayout}
        />
      )}
    </S.LayoutButtonContainer>
  ) : null;
};

export default LayoutButtons;
